"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserIds = void 0;
const user_ids_schema_1 = require("./user-ids.schema");
const base_model_1 = require("../../base-model");
class UserIds extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return user_ids_schema_1.userIdsSchema;
    }
}
exports.UserIds = UserIds;
